import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";

import Button from "../components/Button";
import MenuBar from "../components/MenuBar";
import Privacy from "../components/Privacy";

const Page = styled.div``;

const ButtonLink = Button.withComponent(Link);

export default () => (
  <Page>
    <MenuBar fixed button={<ButtonLink to="/">Home</ButtonLink>} />
    <Privacy />
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/datenschutz.js